export function getTipPriorityColor(priority: number) {
  if (priority >= 4) return 'destructive';
  if (priority >= 3) return 'secondary';
  return 'outline';
}
